import Textarea from '../../../Common/ui/textArea'
import { Pagination, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import AddSquareIcon from '../../../Common/Icon/AddSquareIcon'
import Input from '../../../Common/ui/input'
import SelectInput from '../../../Common/ui/selectInput'
import '../../../Styles/ThresholdLimitQuestions.css'
import { cn } from 'src/lib/utils'
import { useCompStore } from '../Store/ComplianceStore'
import { useTranslation } from 'react-i18next'
import { UOM_AMOUNT_ID, UOM_NUMBER_ID, UOM_PERCENTAGE_ID } from 'src/Entities/Governance'
import ContentCircle from 'src/Common/ui/contentCircle'

function ThresholdLimitQuestions ({ setValue, inputValidation, trigger, activeTab, selectedValues, controls, control, data, errors, onInputChangeTextArea, onValueSelectChange, onInputChange, handleAddControls, handleDeleteControls, i }) {
    const viewCondition = () => {
        const path = location.pathname
        if (path.includes('Add') || path.includes('Edit')) {
            return false
        } else {
            return true
        }
    }
    const { getCompUom, compUom } = useCompStore()
    const [ uom, setUom ] = useState()
    useEffect(() => {
        getCompUom()
    }, [])
    useEffect(() => {
        setUom(compUom)
    }, [compUom])

    const uomSymbol = (value) => {
        switch (value) {
        case UOM_PERCENTAGE_ID:
            return '%'
        case UOM_NUMBER_ID:
            return ''
        case UOM_AMOUNT_ID:
            return ''
        default:
            break
        }
    }
    const [ paginatedData, setPaginatedData ] = useState([])
    const [ currentPage, setCurrentPage ] = useState(1)
    const { t } = useTranslation()
    const rowsPerPage = 5
    const totalPages = Math.ceil(data.length / rowsPerPage)
    const handlePageChange = (event, value) => {
        setCurrentPage(value)
    }

    const uomValidation = () => {
        switch (data[0]?.uom) {
        case UOM_PERCENTAGE_ID:
            return [ 0, 100 ]
        case UOM_NUMBER_ID:
            return [ 0, 1000 ]
        case UOM_AMOUNT_ID:
            return [ 0, 100000 ]
        default:
            break
        }
    }
    const limitsValidation = (difference, value, item, symbol, neighbourName, neighbourValue) => {
        let validNum = ''
        const regexPhone = (value) => {
            const rangeValidation = +value >= +uomValidation()[0] && +value < +uomValidation()[1]
            if (!item && rangeValidation) {
                return true
            } else if (rangeValidation && difference) {
                return true
            } else {
                if (!difference) {
                    validNum = `${symbol} = ${item}`
                } else {
                    validNum = uomValidation()[0] + '-' + uomValidation()[1]
                }
                return false
            }
        }
        if (!value) {
            return 'required'
        } else if (!regexPhone(value)) {
            return validNum
        }
    }
    useEffect(() => {
        if (data.length > 0) {
            if (viewCondition()) {
                setPaginatedData(data.map((item, i) => ({ ...item, sNo: i + 1 })).slice((currentPage - 1) * rowsPerPage, currentPage * rowsPerPage))
            }
        }
    }, [ data, currentPage ])
    const [ disable, setDisable ] = useState(false)

    useEffect(() => {
        if (!viewCondition() && paginatedData.length > 0) {
            const find = paginatedData.every((ele) => {
                return ele.type &&
                ele.applicableLimitMin &&
                ele.applicableLimitMax &&
                ele.regulatoryLimitMin &&
                ele.regulatoryLimitMax &&
                ele.penaltyandFine &&
                ele.damageToReputation
            })
            if (find) {
                setDisable(false)
            } else {
                setDisable(true)
            }
        }
    }, [paginatedData])
    const [ entries, setEntries ] = useState({
        entry: 0,
        from: 0,
        to: 0
    })
    useEffect(() => {
        setEntries({
            entry: data?.length,
            from: (currentPage - 1) * rowsPerPage + 1,
            to: (currentPage - 1) * rowsPerPage + paginatedData?.length - 1 + 1
        })
    }, [paginatedData])
    return (
        <>
            {<div style={{ display: activeTab === 3 ? 'block' : 'none', height: '100% ' }}>
                {!viewCondition() && (viewCondition() ? paginatedData : data).length > 0 && <div className='mb-5'>
                    <SelectInput
                        label="UoM"
                        required
                        control={control}
                        errors={errors}
                        name="Uom"
                        placeholder="Select"
                        defaultValue={data[0]?.uom}
                        onValueChange={(value) => onValueSelectChange(value, 'thresholdLimits-uom')}
                        value={data[0]?.uom}
                        options={uom?.map((ele) => {
                            return {
                                value: ele.id,
                                label: ele.name
                            }
                        })}
                        className='!w-[24%]'
                    />
                </div>}
                <div className='h-[86%]'>
                    <TableContainer className={cn('threshold-comp-table global-table')}>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell align='center' sx={{ border: 'none', position: 'sticky', left: 0 }} colSpan={2}></TableCell>
                                    <TableCell className='comp-table-th' align='center' sx={{ }} colSpan={2}>{t('Applicable limit')}</TableCell>
                                    <TableCell sx={{ padding: 0 }} align='center' colSpan={2}><p className={cn('comp-table-th', 'pl-2')}>{t('Regulatory limit')}</p></TableCell>
                                    <TableCell sx={{ padding: 0 }} align='center' colSpan={2}><p className={cn('comp-table-th', 'pl-2')}>{t('Risk of Non-Compliance limit')}</p></TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell align='center' sx={{ position: 'sticky', left: 0 } }>#</TableCell>
                                    <TableCell align='center' sx={{ position: 'sticky', left: '49px', padding: 0 }}><p style={{ borderRight: '1.5px solid hsl(var(--table-bisector))', width: '300px' }} className={cn('h-[60px] flex items-center')}><p className={cn('comp-table-th', 'pl-2')}>{t('Description')}</p></p></TableCell>
                                    <TableCell align='center' sx={{ padding: 0 }}><p className={cn('pl-2')}>{t('Minimum')}</p></TableCell>
                                    <TableCell align='center' sx={{ padding: 0 }}><p className={cn('comp-table-th', 'pl-2')}>{t('Maximum')}</p></TableCell>
                                    <TableCell align='center' sx={{ padding: 0 }}><p className={cn('comp-table-th', 'pl-2')}>{t('Minimum')}</p></TableCell>
                                    <TableCell align='center' sx={{ padding: 0 }}><p className={cn('comp-table-th', 'pl-2')}>{t('Maximum')}</p></TableCell>
                                    <TableCell align='center' sx={{ padding: 0 }}><p className={cn('comp-table-th', 'pl-2')}>{t('Penalties and fines')}</p></TableCell>
                                    <TableCell align='center' sx={{ padding: 0 }}><p className={cn('comp-table-th', 'pl-2')}>{t('Damage to Reputation')}</p></TableCell>
                                    {data.length > 1 && !viewCondition() && <TableCell sx={{ position: 'sticky', right: '0', zIndex: 2, padding: 0 }} className='w-[40px]'></TableCell>}
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {
                                    (viewCondition() ? paginatedData : data)?.map((item, j) => {
                                        item.sNo = j + 1

                                        return (
                                            <>
                                                <TableRow key={j}>
                                                    <TableCell align='center' sx={{ position: 'sticky', left: 0, zIndex: 2 }}>
                                                        <div className='w-full flex justify-center'>
                                                            <ContentCircle className={'min-h-6 text-center bg-[hsl(var(--primary-table-head))] min-w-6'} contentClassName={'text-primary text-sm'} content={item.sNo} />

                                                        </div>
                                                    </TableCell>
                                                    <TableCell align='center' sx={{ position: 'sticky', left: '49px', zIndex: 2, padding: 0 }}>
                                                        <div className='h-full'>

                                                            <p style={{ borderRight: '1.5px solid hsl(var(--table-bisector))' }} className='!h-full flex items-center'><p className={'threshold-comp-table-td !h-full'}>
                                                                {viewCondition()
                                                                    ? <div className='px-3'>{item.type}</div>
                                                                    : <Textarea
                                                                        errors={errors}
                                                                        control={control}
                                                                        required
                                                                        rules={{
                                                                            validate: (value) => {
                                                                                return inputValidation(value, value?.length < 251, t('This field is required'), t('Characters should be less than 250'))
                                                                            }
                                                                        }}
                                                                        name={`thresholdLimits-type-${j}`}
                                                                        placeholder={t('Enter Description')}
                                                                        type="text"
                                                                        onValueChange={(e) => onInputChangeTextArea(e, `thresholdLimits-type-${j}`)}
                                                                        value={item.type}
                                                                        defaultValue={item.type}
                                                                        className='!border-none  !ring-0 !shadow-none !h-14 !p-0'
                                                                        maxLength={250}
                                                                    />}
                                                            </p>
                                                            </p>
                                                        </div>

                                                    </TableCell>
                                                    <TableCell align='center' >
                                                        <p className={cn('threshold-comp-table-td')} style={{ borderLeft: 'none' }}>
                                                            {viewCondition()
                                                                ? <div className='flex items-center justify-center'>
                                                                    <div>{item.applicableLimitMin}</div>
                                                                    <div>{uomSymbol(item.uom)}</div>
                                                                </div>
                                                                : <div className='flex items-center justify-center'>
                                                                    <div className='h-[63px]'>
                                                                        <Input
                                                                            errors={errors}
                                                                            control={control}
                                                                            required
                                                                            rules={{
                                                                                validate: (value) => {
                                                                                    return limitsValidation(+value <= +item.applicableLimitMax, value, item.applicableLimitMax, '<', `thresholdLimits-applicableLimitMax-${j}`, item.applicableLimitMax)
                                                                                }
                                                                            }}
                                                                            name={`thresholdLimits-applicableLimitMin-${j}`}
                                                                            placeholder={t('Enter Applicable Limit')}
                                                                            type="number"
                                                                            onValueChange={(e) => onInputChange(e, `thresholdLimits-applicableLimitMin-${j}`)}
                                                                            value={item.applicableLimitMin}
                                                                            defaultValue={item.applicableLimitMin}
                                                                            className='!w-[50px] !p=0 !border-none !ring-0 !shadow-none'
                                                                        />
                                                                    </div><div className='pb-2'>{uomSymbol(item.uom)}</div>
                                                                </div>}
                                                        </p>
                                                    </TableCell>
                                                    <TableCell align='center' sx={{ }}>
                                                        <p className={cn('threshold-comp-table-td')}>
                                                            {viewCondition()
                                                                ? <div className='flex items-center justify-center'>
                                                                    <div>{item.applicableLimitMax}</div>
                                                                    <div>{uomSymbol(item.uom)}</div>
                                                                </div>
                                                                : <div className='flex items-center justify-center'>
                                                                    <div className='h-[63px]'>
                                                                        <Input
                                                                            errors={errors}
                                                                            control={control}
                                                                            required
                                                                            rules={{
                                                                                validate: (value) => {
                                                                                    if (+item.applicableLimitMin <= +item.applicableLimitMax) {
                                                                                        trigger(`thresholdLimits-applicableLimitMin-${j}`)
                                                                                    }
                                                                                    return limitsValidation(+value >= +item.applicableLimitMin, value, item.applicableLimitMin, '>')
                                                                                }
                                                                            }}
                                                                            name={`thresholdLimits-applicableLimitMax-${j}`}
                                                                            placeholder={t('Enter Appicable Limit')}
                                                                            type="number"
                                                                            onValueChange={(e) => onInputChange(e, `thresholdLimits-applicableLimitMax-${j}`)}
                                                                            value={item.applicableLimitMax}
                                                                            defaultValue={item.applicableLimitMax}
                                                                            className='!w-[50px] !p=0 !border-none !ring-0 !shadow-none'
                                                                        />
                                                                    </div><div className='pb-2'>{uomSymbol(item?.uom)}</div>
                                                                </div>}
                                                        </p>
                                                    </TableCell>
                                                    <TableCell align='center' sx={{ }}>
                                                        <p className={cn('threshold-comp-table-td')}>
                                                            {viewCondition()
                                                                ? <div className='flex items-center justify-center'>
                                                                    <div>{item.regulatoryLimitMin}</div>
                                                                    <div>{uomSymbol(item.uom)}</div>
                                                                </div>
                                                                : <div className='flex items-center justify-center'>
                                                                    <div className='h-[63px]'>
                                                                        <Input
                                                                            errors={errors}
                                                                            control={control}
                                                                            required
                                                                            rules={{
                                                                                validate: (value) => {
                                                                                    return limitsValidation(+value <= +item.regulatoryLimitMax, value, item.regulatoryLimitMax, '>', `thresholdLimits-regulatoryLimitMax-${j}`, item.regulatoryLimitMax)
                                                                                }
                                                                            }}
                                                                            name={`thresholdLimits-regulatoryLimitMin-${j}`}
                                                                            placeholder={t('Enter Regulatory Limit')}
                                                                            type="number"
                                                                            onValueChange={(e) => onInputChange(e, `thresholdLimits-regulatoryLimitMin-${j}`)}
                                                                            value={item.regulatoryLimitMin}
                                                                            defaultValue={item.regulatoryLimitMin}
                                                                            className='!w-[50px] !p=0 !border-none !ring-0 !shadow-none'
                                                                        />
                                                                    </div><div className='pb-2'>{uomSymbol(item.uom)}</div>
                                                                </div>}
                                                        </p>
                                                    </TableCell>
                                                    <TableCell align='center' sx={{ }}>
                                                        <p className={cn('threshold-comp-table-td')}>
                                                            {viewCondition()
                                                                ? <div className='flex items-center justify-center'>
                                                                    <div>{item.regulatoryLimitMax}</div>
                                                                    <div>{uomSymbol(item.uom)}</div>
                                                                </div>
                                                                : <div className='flex items-center justify-center'>
                                                                    <div className='h-[63px]'>
                                                                        <Input
                                                                            errors={errors}
                                                                            control={control}
                                                                            required
                                                                            rules={{
                                                                                validate: (value) => {
                                                                                    return limitsValidation(+value >= +item.regulatoryLimitMin, value, item.regulatoryLimitMax, '<')
                                                                                }
                                                                            }}
                                                                            name={`thresholdLimits-regulatoryLimitMax-${j}`}
                                                                            placeholder={t('Enter Regulatory Limit')}
                                                                            type="number"
                                                                            onValueChange={(e) => onInputChange(e, `thresholdLimits-regulatoryLimitMax-${j}`)}
                                                                            value={item.regulatoryLimitMax}
                                                                            defaultValue={item.regulatoryLimitMax}
                                                                            className='!w-[50px] !p=0 !border-none !ring-0 !shadow-none'
                                                                        />
                                                                    </div><div className='pb-2'>{uomSymbol(item.uom)}</div>
                                                                </div>}
                                                        </p>
                                                    </TableCell>
                                                    <TableCell align='center' sx={{ }}>
                                                        <p className={cn('threshold-comp-table-td min-w-[170px]')}>
                                                            {viewCondition()
                                                                ? <div className='px-3'>{item.penaltyandFine}</div>
                                                                : <Textarea
                                                                    errors={errors}
                                                                    control={control}
                                                                    required
                                                                    rules={{
                                                                        validate: (value) => {
                                                                            return inputValidation(value, value?.length < 251, t('This field is required'), t('Characters should be less than 250'))
                                                                        }
                                                                    }}
                                                                    name={`thresholdLimits-penaltyandFine-${j}`}
                                                                    placeholder={t('Enter Penalty And Fine')}
                                                                    type="text"
                                                                    onValueChange={(e) => onInputChangeTextArea(e, `thresholdLimits-penaltyandFine-${j}`)}
                                                                    value={item.penaltyandFine}
                                                                    defaultValue={item.penaltyandFine}
                                                                    className='!border-none !ring-0 !shadow-none !h-14 !p-0'
                                                                    maxLength={250}
                                                                />}
                                                        </p>
                                                    </TableCell>
                                                    <TableCell align='center' sx={{ }}>
                                                        <p className={cn('threshold-comp-table-td min-w-[170px]')}>
                                                            {viewCondition()
                                                                ? <div className='px-3'>{item.damageToReputation}</div>
                                                                : <Textarea
                                                                    errors={errors}
                                                                    control={control}
                                                                    required
                                                                    rules={{
                                                                        validate: (value) => {
                                                                            return inputValidation(value, value?.length < 251, t('This field is required'), t('Characters should be less than 250'))
                                                                        }
                                                                    }}
                                                                    name={`thresholdLimits-damageToReputation-${j}`}
                                                                    placeholder={t('Enter Damage And Reputation')}
                                                                    type="text"
                                                                    onValueChange={(e) => onInputChangeTextArea(e, `thresholdLimits-damageToReputation-${j}`)}
                                                                    value={item.damageToReputation}
                                                                    defaultValue={item.damageToReputation}
                                                                    className='!border-none !ring-0 !shadow-none !h-14 !p-0'
                                                                    maxLength={250}
                                                                />}
                                                        </p>
                                                    </TableCell>
                                                    {data.length > 1 && !viewCondition() && <TableCell sx={{ position: 'sticky', right: '0', zIndex: 2, padding: 0 }}><div className='h-full cursor-pointer flex justify-center' onClick={() => handleDeleteControls('thresholdLimits', j)}><img src='/Common/Icon/DeleteIconGov.svg' className='w-[25px] h-[25px]' /></div></TableCell>}
                                                </TableRow>
                                            </>
                                        )
                                    })
                                }

                            </TableBody>
                        </Table>
                    </TableContainer>
                </div>

                {viewCondition() && data.length > 0 && <div className=" border-t-2 border-t-primary-foreground flex items-center justify-between mt-2 p-4 h-[14%]">
                    <Typography className="text-muted !text-h4">
                        Showing data {entries.from} to {entries.to} of {entries.entry} entries
                    </Typography>
                    <Pagination
                        sx={{ marginLeft: 'auto' }}
                        count={totalPages}k
                        page={currentPage}
                        onChange={handlePageChange}
                        variant="outlined"
                        shape="rounded" />
                </div>}
                {!viewCondition() && <div className='w-full flex justify-end mt-5 pr-1 cursor-pointer'>
                    <div className={cn(disable ? 'bg-popover pr-1 rounded-sm !text-card pointer-events-none' : '', 'flex gap-2 items-center text-primary')} onClick={() => { handleAddControls('thresholdLimits'); setValue('Uom', data[0]?.uom) }}><AddSquareIcon fill={disable ? 'hsl(var(--card))' : 'hsl(var(--primary))'} /> <span>New</span></div>

                    {/* <div className='flex gap-2 items-center text-primary' onClick={() => { handleAddControls('thresholdLimits'); setValue('Uom', data[0]?.uom) } }><AddSquareIcon /> <span>New</span></div> */}
                </div>}
            </div>}
        </>
    )
}

ThresholdLimitQuestions.propTypes = {
    selectedValues: PropTypes.array,
    onValueSelectChange: PropTypes.func,
    controls: PropTypes.any,
    control: PropTypes.any,
    errors: PropTypes.any,
    data: PropTypes.any,
    onInputChangeTextArea: PropTypes.func,
    onInputChange: PropTypes.func,
    handleAddControls: PropTypes.func,
    handleDeleteControls: PropTypes.func,
    i: PropTypes.number,
    activeTab: PropTypes.any,
    inputValidation: PropTypes.any,
    setValue: PropTypes.any,
    trigger: PropTypes.any
}

export default ThresholdLimitQuestions
